import React from 'react';

import { Menu } from '@lumapps/lumx-menu/components/Menu';

import { ShareButton, type ShareButtonProps } from '../ShareButton';

export type { ShareButtonProps };

interface ShareMenuButtonProps extends ShareButtonProps {
    buttonRef?: React.Ref<HTMLButtonElement>;
    children: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

/** Base share menu button. */
const BaseShareMenuButton: React.FC<ShareMenuButtonProps> = ({ buttonRef, children, onClick, ...forwardedProps }) => (
    <Menu.Trigger popoverProps={{ minWidth: 'xxl' }}>
        <Menu.TriggerButton ref={buttonRef} as={ShareButton} onClick={onClick} {...forwardedProps} />
        <Menu>{children}</Menu>
    </Menu.Trigger>
);

export const ShareMenuButton = Object.assign(BaseShareMenuButton, { Section: Menu.Section });
